import { render, staticRenderFns } from "./topik_by_source.vue?vue&type=template&id=0083e642"
import script from "./topik_by_source.vue?vue&type=script&lang=js"
export * from "./topik_by_source.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports